export const isLoggedOut = (state) => state.isLoggedOut
export const isSubscribed = (state) => state.isSubscribed
